import React from 'react';
import BlogsHeroSection from '../components/BlogsHeroSection';
import BlogsGridSection from '../components/BlogsGridSection';
import ContactUsSection from '../components/ContactUsSection';
import FooterSection from '../components/FooterSection';

function BlogsPage() {
  return React.createElement('div', { className: 'figma-viewport' },
    React.createElement('div', { className: 'section-animate' }, React.createElement(BlogsHeroSection)),
    React.createElement('div', { className: 'section-animate' }, React.createElement(BlogsGridSection)),
    React.createElement('div', { className: 'section-animate' }, React.createElement(ContactUsSection)),
    React.createElement('div', { className: 'section-animate' }, React.createElement(FooterSection))
  );
}

export default BlogsPage;
